/**
 * Registration
 */
(function ($, _, wp_vars) {
    "use strict";

    const $groups = $("[data-dynamic-group]");
    let cache = {};
    var alreadyInit = false;

    // Support for a SchoolCity value that might be present before or after this runs
    let postedSchoolCity = null;
    let postedSchoolCode = null;
    let appliedPostedCityOnce = false;

    function readPostedSchoolCity() {
        // 1) global set elsewhere: window.mefaPosted = { SchoolCity: "Providence" }
        if (window.mefaPosted && typeof window.mefaPosted.SchoolCity === "string") {
            return window.mefaPosted.SchoolCity.trim();
        }
        // 2) hidden field: <input type="hidden" id="postedSchoolCity" value="Providence">
        const hidden = document.getElementById("postedSchoolCity");
        if (hidden && hidden.value) return hidden.value.trim();
        // 3) prefilled select value
        const serverPrefill = document.querySelector('select[name="SchoolCity"]');
        if (serverPrefill && serverPrefill.value) return String(serverPrefill.value).trim();
        // 4) <body data-posted-school-city="Providence">
        const fromBody = document.body && document.body.getAttribute("data-posted-school-city");
        if (fromBody) return fromBody.trim();
        return null;
    }

    // Read the previously submitted SchoolCode before the school list is rebuilt.
    function readPostedSchoolCode() {
        if (window.mefaPosted && typeof window.mefaPosted.SchoolCode === "string") {
            return window.mefaPosted.SchoolCode.trim();
        }

        const schoolSelect = document.querySelector('select[name="SchoolCode"]');
        if (schoolSelect) {
            const initialSelection = schoolSelect.getAttribute("data-initial-selection");
            if (initialSelection) return String(initialSelection).trim();
        }

        return null;
    }

    // Custom event hook if another script sets the city later
    // document.dispatchEvent(new CustomEvent('mefa:postedSchoolCity', { detail: 'Providence' }));
    document.addEventListener(
        "mefa:postedSchoolCity",
        function (e) {
            if (e && e.detail) {
                postedSchoolCity = String(e.detail).trim();
                appliedPostedCityOnce = false;
            }
        },
        { passive: true }
    );

    postedSchoolCity = readPostedSchoolCity();
    postedSchoolCode = readPostedSchoolCode();

    // “Other school” conditional field
    (function otherSchool() {
        const template = `<div class="form-field" id="NewSchool">
      <label class="form-field__label" for="SchoolName">School Name*</label>
      <div class="form-field__input">
        <input type="text" name="SchoolName" id="SchoolName" value="">
      </div>
    </div>`;

        $("#SchoolCode.newstudent").on(
            "change",
            _.debounce(
                function () {
                    if ($(this).val() === "00000000") {
                        $(this).parents("#SchoolCodeDiv").after(template);
                    } else {
                        $("#NewSchool").remove();
                    }
                },
                300,
                { leading: true, trailing: false }
            )
        );
    })();

    // Simple chained timeouts
    function delay(fn, t) {
        var queue = [], self, timer;
        function schedule(fn, t) {
            timer = setTimeout(function () {
                timer = null;
                fn();
                if (queue.length) {
                    var item = queue.shift();
                    schedule(item.fn, item.t);
                }
            }, t);
        }
        self = {
            delay: function (fn, t) {
                if (queue.length || timer) {
                    queue.push({ fn: fn, t: t });
                } else {
                    schedule(fn, t);
                }
                return self;
            },
            cancel: function () {
                clearTimeout(timer);
                queue = [];
                return self;
            },
        };
        return self.delay(fn, t);
    }

    // Demo/test autofill
    function testMode() {
        if (!location.search.includes("?test")) return;

        const firstName = "First-" + Math.random().toString(36).substring(2, 8) + Math.random().toString(36).substring(2, 8);
        const lastName = "Last-" + Math.random().toString(36).substring(2, 8) + Math.random().toString(36).substring(2, 8);
        if (!$('input[name="Firstname"]').val()) $('input[name="Firstname"]').val(firstName);
        if (!$('input[name="Lastname"]').val()) $('input[name="Lastname"]').val(lastName);
        if (!$('input[name="BirthDate"]').val()) $('input[name="BirthDate"]').val("04/22/2008");

        $('select[name="Country"]').val("US").trigger("change");
        delay(() => { $('select[name="State"]').val("RI").trigger("change"); }, 1000)
            .delay(() => { $('select[name="SchoolCity"]').val("Providence").trigger("change"); }, 1500)
            .delay(() => { $('select[name="SchoolCode"]').val("FT0000005").trigger("change"); }, 1500);

        $('input[name="PEAddrLine1"]').val("100 Main St");
        $('input[name="PECity"]').val("Dover");
        $('input[name="PEZip"]').val("02030");
        $('select[name="ExpGradYear"]').val("2026").trigger("change");

        const username = "TEST" + Math.random().toString(36).substring(2, 8) + Math.random().toString(36).substring(2, 8);
        const email = `${username}@kevinleary.net`;
        const password = "Abc123$%";
        $('input[name="Username"]').val(username);
        $('input[name="Email1"]').val(email);
        $('input[name="confirmEmail"]').val(email);
        $('input[name="Password"]').val(password);
        $('input[name="confirmPassword"]').val(password);
        $('input[name="Question"]').val("What's 1 + 3?");
        $('input[name="Answer"]').val("four");
        $('input[name="Question2"]').val("What's 1 + 4?");
        $('input[name="Answer2"]').val("five");
        $('input[name="TOC"]').prop("checked", true);
        $('input[name="StudentAgreement"]').prop("checked", true);
    }
    $(window).on("load", testMode);

    // Elements
    $groups.each(function () {
        const group = $(this).data("dynamic-group");
        const $country = $(`[data-dynamic-options="country"][data-dynamic-group="${group}"]`);
        const $state = $(`[data-dynamic-options="state"][data-dynamic-group="${group}"]`);
        const $city = $(`[data-dynamic-options="city"][data-dynamic-group="${group}"]`);
        const $schools = $(`[data-dynamic-options="school"][data-dynamic-group="${group}"]`);

        function init() {
            if (alreadyInit) return false;
            alreadyInit = true;
            resetDropdowns();
            conditionalStateInput();
            conditionalCityOptions();
            conditionalSchoolOptions();
        }

        function resetDropdowns() {
            $country.off("change");
            $state.off("change");
            $city.off("change");
            $schools.off("change");

            $country.empty().select2({ data: countries, placeholder: "Choose..." });
            $state.empty().select2({ data: states, placeholder: "Select a State" });
            $city.empty().select2({ data: cities, placeholder: "Select a State First" });
            $city.prop("disabled", true);

            var placeholder_school = _mefa ? "Select a City/Town First" : "Select a State First";
            $schools.empty().select2({ data: schools, placeholder: placeholder_school });
            $schools.prop("disabled", true);
        }

        function conditionalStateInput() {
            $country.on(
                "change",
                _.debounce(
                    function () {
                        const selected = $country.val();

                        $state.prop("disabled", false);
                        if (selected === "Other") {
                            $state.parents(".form-field").hide();
                            $city.parents(".form-field").hide();
                            $schools.parents(".form-field").hide();
                            $state.val("Other").trigger("change");
                            $city.val("Other").trigger("change");
                            $schools.val("00000000").trigger("change");
                        } else {
                            $state.parents(".form-field").show();
                            $city.parents(".form-field").show();
                            $schools.parents(".form-field").show();
                            $state.val(null).trigger("change");
                            $city.val(null).trigger("change");
                            $schools.val(null).trigger("change");
                        }
                    },
                    300,
                    { leading: true, trailing: false }
                )
            );
        }
        
        // Validate BirthDate: applicant must be between 8 and 30 years old.
        function validateBirthDate(value) {
            if (!value) {
                return false;
            }

            var birthDate = new Date(value + 'T00:00:00');

            if (isNaN(birthDate.getTime())) {
                return false;
            }

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            // Calculate age accurately based on whether the birthday has occurred this year.
            var age = today.getFullYear() - birthDate.getFullYear();
            var monthDifference = today.getMonth() - birthDate.getMonth();

            if (
                monthDifference < 0 ||
                (monthDifference === 0 && today.getDate() < birthDate.getDate())
            ) {
                age--;
            }

            return age >= 8 && age <= 30;
        }

        function clearCityAndSchools() {
            $city.empty().select2({ data: cities, placeholder: "Select a State First" });
            $schools.empty().select2({ data: schools, placeholder: "Select a City First" });
        }

        function conditionalCityOptions() {
            $state.on(
                "change input",
                _.debounce(
                    function () {
                        const state = $state.val();
                        const empty = state == "" || state == null;

                        $city.prop("disabled", true);
                        $schools.prop("disabled", true);
                        clearCityAndSchools();

                        const $peState = $('input[name="PEState"]');
                        if ($peState.length) $peState.val(state);

                        if (empty) return;

                        const other = state == "Other";
                        if (other) {
                            $schools.parents(".form-field").hide();
                            $city.parents(".form-field").hide();
                            return;
                        }

                        $city.parents(".form-field").show();
                        $schools.parents(".form-field").show();

                        const req = $.ajax({
                            url: `/api/dictionary/MEFAOrgs/?MailingState=${state}`,
                            cache: true,
                            global: false,
                        });

                        req.done((resp) => {
                            let cityNames = [];
                            _.each(resp.result, (school) => {
                                cityNames.push(school.MailingCity);
                            });

                            cityNames = _.uniq(cityNames);

                            cities = [{ id: "", text: "Choose..." }];
                            _.each(cityNames, (cityName) => {
                                cities.push({ id: cityName, text: cityName });
                            });

                            $city.empty().select2({ data: cities, placeholder: "Choose..." });
                            $city.prop("disabled", false);

                            function tryApplyPostedCity() {
                                if (!postedSchoolCity || appliedPostedCityOnce) return false;
                                const match = cities.find(
                                    (opt) => opt.id && String(opt.id).toLowerCase() === postedSchoolCity.toLowerCase()
                                );
                                if (match) {
                                    appliedPostedCityOnce = true;
                                    $city.val(match.id).trigger("change");
                                    return true;
                                }
                                return false;
                            }

                            if (!tryApplyPostedCity()) {
                                if (!postedSchoolCity) postedSchoolCity = readPostedSchoolCity();
                                $city.val(null).trigger("change");
                                setTimeout(() => {
                                    if (!postedSchoolCity) postedSchoolCity = readPostedSchoolCity();
                                    tryApplyPostedCity();
                                }, 250);
                            }
                        });

                        req.fail((error) => {
                            console.error(error);
                        });
                    },
                    300,
                    { leading: true, trailing: false }
                )
            );

            if (_mefa) {
                $state.trigger("change");
            }
        }

        function conditionalSchoolOptions() {
            $city.on(
                "change",
                _.debounce(
                    function () {
                        const state = $state.val();

                        if (!postedSchoolCity) postedSchoolCity = readPostedSchoolCity();

                        const city = ($city.val() || postedSchoolCity || "");
                        const empty = city == "" || city == null;

                        $schools.prop("disabled", true);

                        var placeholder_school = _mefa ? "Select a City/Town First" : "Select a State First";
                        if (empty) {
                            $schools.empty().select2({ data: [], placeholder: placeholder_school });
                            return;
                        }

                        const other = city == "Other";
                        if (other) {
                            $schools.parents(".form-field").hide();
                            var placeholder_school2 = _mefa ? "Select a City/Town First" : "Select a State First";
                            $schools.empty().select2({ data: [], placeholder: placeholder_school2 });
                            return;
                        }

                        $schools.parents(".form-field").show();

                        const req = $.ajax({
                            url: `/api/dictionary/MEFAOrgs/?MailingState=${state}&MailingCity=${encodeURIComponent(city)}`,
                            cache: true,
                            global: false,
                        });

                        req.done((resp) => {
                            schools = [{ id: "", text: "Choose..." }];

                            _.each(resp.result, (school) => {
                                schools.push({
                                    id: school.OrgId,
                                    text: school.OrgName,
                                    value: school.OrgId,
                                });
                            });

                            $schools.empty().select2({ data: schools, placeholder: "Choose..." });
                            $schools.prop("disabled", false);

                            // Restore SchoolCode after the AJAX-loaded school options are available.
                            if (
                                postedSchoolCode &&
                                $schools.find('option[value="' + postedSchoolCode + '"]').length
                            ) {
                                $schools.val(postedSchoolCode).trigger("change");

                                // Prevent later city changes from restoring the original school.
                                postedSchoolCode = null;
                            } else {
                                $schools.val(null).trigger("change");
                            }
                        });

                        req.fail((error) => {
                            console.error(error);
                        });
                    },
                    300,
                    { leading: true, trailing: false }
                )
            );
        }

        $("#ExpGradYear").on("change", function () {
            let $this = $(this);
            let max = parseInt($this.attr("max"));
            let min = parseInt($this.attr("min"));
            let value = parseInt($this.val());
            if (value > max) $this.val(max);
            if (value < min) $this.val(min);
        });

        init();
    });
})(window.jQuery, window._, window.wp_vars);